import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCloseCross = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 17,
	viewBox: "0 0 17 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.9219 1.71397L15.3104 0.102539L8.92188 6.49111L2.5333 0.102539L0.921875 1.71397L7.31045 8.10254L0.921875 14.4911L2.5333 16.1025L8.92188 9.71397L15.3104 16.1025L16.9219 14.4911L10.5333 8.10254L16.9219 1.71397Z",
		fill: "currentColor"
	})
});
export default SvgCloseCross;
